import { useSearchParams } from "react-router-dom";
import { useWindowSize } from "@hooks/useWindowSize";
import useOKTAUserStore, { OKTAUserTypeEnum } from "@store/useOKTAUserStore";
import { useDetectAdBlock } from "adblock-detect-react";
import Cookies from "js-cookie";

import PrestitialAd from "./PrestitialAd";

export type PrestitialAdWrapperProps = {
  isPrestitialEnabled: boolean;
  slot: string;
  topOverlayImpressions: number;
  topOverlayValidity: number;
};

export default function PrestitialAdWrapper({
  isPrestitialEnabled,
  slot,
  topOverlayImpressions, // Maximum total number of impressions
  topOverlayValidity, // Validity of topoverlay cookie in hours
}: PrestitialAdWrapperProps): React.ReactElement {
  const OKTAUserInfo = useOKTAUserStore((state) => state.userInfo);
  const adBlockDetected = useDetectAdBlock();
  const { isScreenMD } = useWindowSize();
  const [searchParams] = useSearchParams();

  const topOverlayDisplayedCookie = Cookies.get("topoverlayDisplayed");
  const topOverlayImpressionsServedCookie = Cookies.get(
    "topOverlayImpressionsServed"
  );

  const totalImpressionsServed =
    parseInt(topOverlayImpressionsServedCookie || "0") || 0;

  const displayPrestitial =
    OKTAUserInfo?.usertype !== OKTAUserTypeEnum.SUBSCRIBER && // Display only for non subscriber
    isPrestitialEnabled && // Variable coming from prebid.js, controlled by ads team.
    isScreenMD && // Display only non mobile devices
    !adBlockDetected && // Display if there is no adblocker
    totalImpressionsServed <= topOverlayImpressions && // Display until maximum impressions reached
    typeof topOverlayDisplayedCookie === "undefined"; // Display if cookie is NOT present

  const hasDfpPreview = typeof searchParams.get("dfp_preview") === "string"; // Override for prestitial

  return (
    <>
      {displayPrestitial || hasDfpPreview ? (
        <PrestitialAd
          {...{
            slot,
            topOverlayImpressions,
            totalImpressionsServed,
            topOverlayValidity,
            adBlockDetected,
          }}
        />
      ) : null}
    </>
  );
}
